import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveWinnersDrops } from "./drops/WaveWinnersDrops";
import { WaveWinnersPodium } from "./podium/WaveWinnersPodium";
import { WaveWinnersTimeline } from "./WaveWinnersTimeline";
import { useWaveDecisions } from "@/hooks/waves/useWaveDecisions";
import { useLayout } from "@/components/brain/my-stream/layout/LayoutContext";
import { useWave } from "@/hooks/useWave";
interface WaveWinnersProps {
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const WaveWinners: React.FC<WaveWinnersProps> = t0 => {
  const $ = _c(11);
  const {
    wave,
    onDropClick
  } = t0;
  const {
    decisions: t1
  } = useWave(wave);
  const {
    multiDecision
  } = t1;
  const {
    winnersViewStyle
  } = useLayout();
  let t2;
  if ($[0] !== wave.id) {
    t2 = {
      waveId: wave.id,
      enabled: true
    };
    $[0] = wave.id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    decisionPoints,
    isFetching: isDecisionsLoading
  } = useWaveDecisions(t2);
  let t3;
  if ($[2] !== decisionPoints || $[3] !== isDecisionsLoading || $[4] !== multiDecision || $[5] !== onDropClick || $[6] !== wave) {
    t3 = multiDecision ? <WaveWinnersTimeline onDropClick={onDropClick} decisionPoints={decisionPoints} wave={wave} isLoading={isDecisionsLoading} /> : <div className="tw-mt-2 tw-flex-grow tw-space-y-2 tw-pb-6 lg:tw-pr-2"><WaveWinnersPodium onDropClick={onDropClick} winners={decisionPoints[0]?.winners ?? []} isLoading={isDecisionsLoading} /><WaveWinnersDrops wave={wave} onDropClick={onDropClick} winners={decisionPoints[0]?.winners ?? []} isLoading={isDecisionsLoading} /></div>;
    $[2] = decisionPoints;
    $[3] = isDecisionsLoading;
    $[4] = multiDecision;
    $[5] = onDropClick;
    $[6] = wave;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3 || $[9] !== winnersViewStyle) {
    t4 = <div className="tw-space-y-4 tw-overflow-y-auto tw-px-2 tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 hover:tw-scrollbar-thumb-iron-300 lg:tw-space-y-6" style={winnersViewStyle}>{t3}</div>;
    $[8] = t3;
    $[9] = winnersViewStyle;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};